<template>
    <section class="sticky-bottom">
        <div class="sticky-bottom__container">
            <img v-if="$store.state.settings.runtime.interactiveDiscussionShowAvatar && speeker.userId !== undefined && speeker.userId > 0" class="sticky-bottom__container__avatar" :src="getUserAvata()" :alt="`${speeker.surname}}`" />
            <div class="sticky-bottom__container__text">
                <p class="speaker-name-container">{{speeker.name}} {{speeker.surname}}</p>
                <p class="speaker-role-container">{{speeker.role}}</p>
            </div>
            <div class="user-speech-time" :class="{'user-speech-time--red' : isSpeakOutOfRange}"><span v-if="isSpeakOutOfRange">+</span>{{displayTime}}</div>
            <img src="../../assets/icons/components/speaker-white.svg" :alt="$t('com.file.speeker-modal.user-speek')" class="user-speech-image" />
        </div>
    </section>
</template>

<script charset="utf-8">
    import CommonHelper from '@/helpers/common.helper.js';
    import { debounce } from '../../helpers/utils';
    import { captureServerReference, emptyServerReference, speechTime } from '../../helpers/speech.time.helper';

    export default {
        name: "SpeekerModal",
        data() {
            return {
                session: {},
                code: '',
                error: false,
                client: '',
                debounceFlag: false,
                serverReference: emptyServerReference(),
                isSpeakOutOfRange: false,
                displayTime: "00:00:00",
                avatarVersion: CommonHelper.getRandomVersionImageForUrlRefresh(0, 100)
            };
        },
        props: {
            speeker: Object,
        },
        watch: {
            debounceFlag: debounce(function () {
                const time = speechTime(this.speeker, this.serverReference);

                this.isSpeakOutOfRange = time.isOvertime;
                this.displayTime = time.label;

                this.debounceFlag = !this.debounceFlag;
            }, 100),
            speeker: {
                immediate: true,
                deep: true,
                async handler() {
                    // punkt odniesienia pobierany na kazda zmiane mowcy - tak jak dotad
                    this.serverReference = await captureServerReference();
                    this.debounceFlag = !this.debounceFlag;
                }
            }
        },
        methods: {
            getUserAvata() {
                return `https://api.esesja.pl/users/${this.speeker.userId}.jpg${this.avatarVersion}`;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .speaker-role-container {
        font-size: 1.4em;
    }

    .speaker-name-container {
        font-weight: bold;
        font-size: 2.4em;
        margin-bottom: 16px
    }

    .sticky-bottom {
        position: -webkit-sticky;
        position: sticky;
        bottom: 0;
        border-color: red;
        background: radial-gradient( 100% 100% at 0% 0%, #00082c 0%, #004dcc 100% );
        height: 140px;

        &__container {
            display: flex;
            font-size: 25px;
            line-height: 144%;
            color: white;
            padding: 25px;

            &__avatar {
                width: 100px;
                vertical-align: middle;
            }

            &__text {
                margin: 10px;
                display: unset;
            }
        }
    }

    .user-speech-image {
        height: 80px;
        right: 40px;
        position: absolute;
        color: white;
        animation: pulse 2s infinite;
    }

    .user-speech-time {
        right: 150px;
        position: absolute;
        color: white;
        font-size: 36px;

        &--red{
            color: #ff0018;
        }
    }

    @keyframes pulse {
        0% {
            opacity: 0;
        }

        50% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }
</style>